export default "__VITE_ASSET__Bm_60JhA__"